import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';

import { provideServiceWorker } from '@angular/service-worker';
import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import { isDevMode, LOCALE_ID } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authApihInterceptor } from './app/_Interceptors/auth-apih-interceptor';

registerLocaleData(localeNl);


bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(
      routes, 
      withComponentInputBinding(), 
      withRouterConfig({ paramsInheritanceStrategy: 'always' }), 
      withPreloading(PreloadAllModules)
    ),
    provideHttpClient(withInterceptors([authApihInterceptor])),
    { provide: LOCALE_ID, useValue: 'nl-BE' }, 
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    })
  ]
});
